export default __webpack_public_path__ + "static/media/bg.c7276b2e.jpg";